import React, { Component } from 'react'
import { Button, Table, Modal, Divider, Spin, Popconfirm, message } from "antd"
import styled from "styled-components"
import RoleForm from '@/components/Role/RoleForm'
import RoleAPI from '@/API/role'
import MenuAPI from '@/API/menu'
import { setMenus } from '@/store/actionCreators'
import { connect } from 'react-redux'
import { withTranslation } from 'react-i18next';


const ButtonContainer=styled.div`
  text-align:right;
`

const AddButton=styled(Button)`
  margin:20px 20px;
`

const RoleTable=styled(Table)`
  margin:0 20px;
`

class Role extends Component {
  constructor(props) {
    super(props);
    this.state = { 
      roleList:[],
      modalType:'add',
      modalShow:false,
      confirmLoading:false,
      formRole:{
        name:'',
        menuIds:[],
        subRoleIds:[]
      },
      pagination:{
        current:1,
        pageSize:20,
        total:0,
        showSizeChanger:true,
        size:'small',
        showTotal:(total)=>(this.props.t('Total items',{total:total}))
      }
    };
    this.columns=[
      {
        title:this.props.t('Role'),
        width:150,
        dataIndex:'name',
        key:'name'
      },
      {
        title:this.props.t('Accessible Menus'),
        render:(text,record)=>{
          return record.menuIds.map((id)=>{
            let menuMatched=this.props.menus.find((menu)=>{
              return menu.id===id
            })
            return menuMatched?menuMatched.name:null
          }).join('，')
        }
      },
      {
        title:this.props.t('Operation'),
        width:150,
        align:'center',
        render:(text,record)=>(
          <span>
            <a onClick={()=>this.initEdit(record)}>{this.props.t('Edit')}</a>
            <Divider type="vertical" />
            <Popconfirm title={this.props.t('Delete the role?')} okType="danger" onConfirm={()=>this.deleteRole(record)}>
              <a>{this.props.t('Delete')}</a>
            </Popconfirm>
          </span>
        )
      }
    ]
  }

  componentDidMount() {
    //请求角色
    this.getRoleList()
    MenuAPI.getAllMenu().then((res)=>{
      if(!res){
        return
      }
      this.props.setMenus(res.menus)
    }).catch((err)=>{
      console.log(err)
    })
  }
  
  getRoleList=()=>{
    this.setState({loading:true})
    const {pagination}=this.state
    RoleAPI.getRoleList({pageIndex:pagination.current-1,pageSize:pagination.pageSize}).then((res)=>{
      this.setState((state)=>{
        return {roleList:res.roles,pagination:{...state.pagination,total:res.totalCount}}
      })
      this.setState({loading:false})
    })
  }
  handleFormChange = (changedFields,name) => {       
    if(name ==='menu'){
      this.setState(({ formRole }) => {
        //赋值编辑的权限
        formRole.menuIds = changedFields;
        return {
          formRole: { ...formRole }
        }
      })   
    }
    if(name ==='sub'){
      this.setState(({ formRole }) => {
        //赋值编辑的权限
        formRole.subRoleIds = changedFields;
        return {
          formRole: { ...formRole }
        }
      }) 
    }    
  }
 
  handleTableChange=(pagination)=>{
    this.setState({
      pagination: pagination,
    },()=>{
      this.getRoleList()
    });
  }
  initAdd=()=>{
    this.setState({
      modalType:'add',
      modalShow:true,
      formRole:{
        name:'',
        menuIds:[]
      }
    })
  }
  initEdit=(role)=>{
    console.log(role,'edit');
    this.setState({
      modalType:'edit',
      modalShow:true,
      formRole:role
    })
  }
  addRole(role){
    this.setState({confirmLoading:true})
    RoleAPI.addRole(role).then((res)=>{
      if(!res.code){
        this.hideModal()
        message.success('添加成功')
        this.getRoleList()
      }
      this.setState({confirmLoading:false})
    }).catch(()=>{
      this.setState({confirmLoading:false})
    })
  }
  editRole(role){
    this.setState({confirmLoading:true})
    RoleAPI.editRole(role).then((res)=>{
      if(!res.code){
        this.hideModal()
        message.success('编辑成功')
        this.getRoleList()
      }
      this.setState({confirmLoading:false})
    }).catch(()=>{
      this.setState({confirmLoading:false})
    })
  }
  deleteRole(role){
    RoleAPI.deleteRole({id:role.id}).then((res)=>{
      if(!res.code){
        message.success('删除成功')
        this.getRoleList()
      }
    })
  }
  hideModal(){
    this.setState({modalShow:false})
  }
  handleOk=()=>{   
    const form=this.formRef.props.form
    form.validateFields((err,values)=>{
      if(err){
        return
      }
      if(this.state.modalType==='add'){
        this.addRole(values)
      }else{
        this.editRole(this.state.formRole)
      }
    })
  }
  handleCancel=()=>{
    this.hideModal()
  }
  saveFormRef=(formRef)=>{
    this.formRef=formRef
  }
  render() {    
    const {roleList,loading,pagination,modalType,modalShow,confirmLoading,formRole} = this.state    
    const { t } = this.props;    
    return (
      <div>
        <ButtonContainer>
          <AddButton type="primary" onClick={this.initAdd}>{t('Add Role')}</AddButton>
        </ButtonContainer>
        <Spin spinning={loading}>
          {
            roleList&&roleList.length?<RoleTable dataSource={roleList} columns={this.columns} pagination={pagination} rowKey="id" onChange={this.handleTableChange}></RoleTable>:<div></div>
          }
        </Spin>
        {
          modalShow&&(
            <Modal maskClosable={false} title={modalType==='add'?t('Add Role'):t('Edit Role')} visible={modalShow} onOk={this.handleOk} confirmLoading={confirmLoading} onCancel={this.handleCancel}>
              <RoleForm wrappedComponentRef={this.saveFormRef} role={formRole} menus={this.props.menus} onChange={this.handleFormChange} allRole={roleList}></RoleForm>
            </Modal>
          )
        }
      </div>
    );
  }
}

const mapStateToProps=(state)=>{
  return {
    menus:state.menus
  }
}

const mapDispatchToProps = { setMenus }

export default connect(mapStateToProps,mapDispatchToProps)(withTranslation()(Role))
